import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Fade, Flip, Rotate, Zoom } from 'react-reveal';

import '../stylesheets/IndieChef.css';

import BackButton from '../shared/BackButton';
import BacktoTop from '../shared/BacktoTopButton';
import ProjectFooter from '../shared/ProjectFooter'

import image1 from '../assets/images/Era/image1.jpg';
import image2 from '../assets/images/Indiechef/image2.jpg';
import image3 from '../assets/images/Indiechef/image3.jpg';
import image4 from '../assets/images/Indiechef/image4.JPG';
import image5 from '../assets/images/Indiechef/image5.jpg';
import image6 from '../assets/images/Indiechef/image6.jpg';
import image7 from '../assets/images/Indiechef/image7.jpg';
import image8 from '../assets/images/Indiechef/image8.jpg';
import image9 from '../assets/images/Indiechef/image9.jpg';







import { Desktop, Tablet, Mobile, Phone } from '../shared';
class IndieChef extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
          <div style = {{backgroundColor:'#e4e4e4'}}>
              <Desktop>
              <BackButton/>
              <BacktoTop/>
              <Fade>
                <Row style = {{maxwidth : '100%', padding:'0', margin:'0'}} >
                  <div className="brandContainer4 brandLanding5">
                    <div className="mugenTitle">
                      <h2>Indie Chef </h2>
                      <h3 style={{fontFamily: 'Open Sans'}}>Eat authentic food, locally prepared<br/> by an independent chef.</h3>
                    </div>
                  </div>
                </Row>
              </Fade>
                <Container>
                  <Row>
                    <Col xs = '12' className = 'intropassage'>
                      <p style = {{color:'#0080E2'}}>Work in progress</p>
                      <p>This project consisted of me designing a mobile mock for a platform that empowers independent chefs to satisfy diners. </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs = '12' className = 'wireframe'>
                      <Fade bottom>
                      <img src = {image2}/>
                      <img className='problem' src = {image3}/>
                      </Fade>
                    </Col>
                  </Row>
                </Container>
                <Fade left>
                  <Row className = 'row2'>
                    <Col xs = '8' className = 'video1'>
                      <img src = {image4}/>
                    </Col>
                    <Col xs ='4' className = 'importwallet'>
                      <h1>Sign-up flow</h1>
                      <p> Simple sign up process where the user can choose to sign up with facebook or create a dedicated account to Indie Chef</p>
                      
                    </Col>
                  </Row>
                </Fade>
                <Container>
                  <Fade botom>
                    <Row className = 'row3'>
                      <Col xs = '12' className = 'image3'>
                      <h3>Explore and order</h3>
                      <img src = {image5}/>
                      </Col>
                    </Row>
                    <Row className = 'row4'>
                      <Col xs = '12' className = 'video2'>
                        <img src = {image6}/>
                      </Col>
                    </Row>
                    <Row className = 'row4'>
                      <Col xs = '12' className = 'video2'>
                      <h3>Chef dashboard</h3>
                        <img src = {image7 }/>
                      </Col>
                    </Row>
                    <Row className = 'row4'>
                      <Col xs = '12' className = 'video2'>
                        <img src = {image8}/>
                      </Col>
                    </Row>
                  </Fade>
                </Container>
                <Fade>
                  <Row className = 'banner2'>
                    <Col xs = '12'  className = 'title2'>
                      <img src = {image9}/>
                    </Col>
                  </Row>
                </Fade>
                <Container>
                  <ProjectFooter/>
                </Container>
            </Desktop>
            <Tablet>
              <h1>not responsive to tablet yet wip :(</h1>
            </Tablet>
            <Mobile>
              <h1>not responsive to mobile yet wip :(</h1>
            </Mobile>

          </div>
        );
    }
}

export default IndieChef



// WEBPACK FOOTER //
// ./src/components/IndieChef.js